import { type UseRouteMatchOptions, useRouteMatch as useFireflyRouteMatch } from "@squide/firefly";
import type { Route } from "./route.ts";

export function useRouteMatch(locationArg: Partial<Location>, options: UseRouteMatchOptions = {}) {
    const route = useFireflyRouteMatch(locationArg, options);

    return route as Route;
}
